import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

const defaultCartPaymentData: IDataLayer = {
  applePayButtonClick: {
    event_name: 'cart_payment_options',
    event_category: 'viewcart',
    event_action: 'cart_payment_options',
    event_label: 'apple_pay',
    enh_action: 'checkout_option',
    checkout_option: 'apple_pay',
  },
  applePayOverlay: {
    event_name: 'apple_pay_overlay',
    event_category: 'viewcart',
    event_action: 'apple_pay_session_begins',
    event_label: 'apple_pay_session_begins',
  },
  payPalButtonClick: {
    event_name: 'cart_payment_options',
    event_category: 'viewcart',
    event_action: 'cart_payment_options',
    event_label: 'paypal',
    enh_action: 'checkout_option',
    checkout_option: 'paypal',
  },
};

function trackCartPayment(_: string, eventData: IDataLayer = {}) {
  tealium.evtLink({
    ...defaultCartPaymentData[eventData?.paymentMode],
    ...eventData,
  });
}

registerAnalyticsEventHandler('cartPayment', trackCartPayment);
